// Help-section destinations. PLACEHOLDERS — the business supplies the real URLs and the official
// WhatsApp number/asset before release (plan §4); keeping them in one block makes that a one-file swap.
const helpConfig = {
    // WhatsApp support is off for now — the business hasn't confirmed the number or that the
    // channel is staffed. Set this to true to put the help-section tile back.
    whatsAppEnabled: false,
    whatsAppNumber: "442084926868",            // wa.me format, no + or spaces — PLACEHOLDER
    phoneDisplay: "020 8492 6868",
    contactUrl: "https://www.olympicholidays.com/contact-us/",             // PLACEHOLDER
    faqUrl: "https://www.olympicholidays.com/help/faq/",
    // Island Hopping bookings (iVector brand "Island Hopping", code IH) have their own FAQ.
    islandHoppingFaqUrl: "https://www.olympicholidays.com/help/island-hopping-secondary-islands-faq/",
    transferInfoUrl: "https://www.olympicholidays.com/help/transfer-information/",
};

/** The FAQ page for a booking's brand (the booking model's productType = iVector BrandName). */
export const faqUrlFor = (productType) =>
    /island\s*hop/i.test(productType || "") ? helpConfig.islandHoppingFaqUrl : helpConfig.faqUrl;

export default helpConfig;